import PortalIdParser from 'PortalIdParser';
export function redirectTo2FASetup(returnUrl) {
  const portalId = PortalIdParser.get();
  const newURL = `/user-preferences${portalId ? `/${portalId}` : ''}/security?setup2faFromNudge=${returnUrl}`;
  window.location.assign(newURL);
}